module.exports = __webpack_public_path__ + "img/Group 849.b19b62c2.png";